import { makeAutoObservable } from 'mobx';
import { Option } from '../model/professional/option-model';

class OptionStore {
  // État des options
  options: Option[] = [];
  isLoading = false;
  error: string | null = null;
  
  // État de la catégorie parente sélectionnée
  selectedCategoryId: string | null = null;
  
  // Option sélectionnée (pour l'édition ou la visualisation)
  selectedOption: Option | null = null;
  
  constructor() {
    makeAutoObservable(this);
  }
  
  /**
   * Méthode pour accéder aux données
   */
  getOptionById(optionId: string): Option | undefined {
    return this.options.find(option => option.id === optionId);
  }
  
  /**
   * Méthode pour définir les options dans le store
   */
  setOptions(options: Option[]) {
    this.options = options;
  }
  
  /**
   * Méthode pour définir la catégorie parente sélectionnée
   */
  setSelectedCategoryId(categoryId: string | null) {
    this.selectedCategoryId = categoryId;
  }
  
  /**
   * Méthode pour définir l'option sélectionnée
   */
  setSelectedOption(option: Option | null) {
    this.selectedOption = option;
  }
  
  /**
   * Méthodes pour gérer l'état de chargement
   */
  setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
  
  /**
   * Méthode pour gérer les erreurs
   */
  setError(error: string | null) {
    this.error = error;
  }
  
  /**
   * Méthode pour ajouter une option au store
   */
  addOption(option: Option) {
    const existingIndex = this.options.findIndex(o => o.id === option.id);
    if (existingIndex >= 0) {
      // Mise à jour d'une option existante
      this.options[existingIndex] = option;
    } else {
      // Ajout d'une nouvelle option
      this.options.push(option);
    }
  }
  
  /**
   * Méthode pour mettre à jour une option dans le store
   */
  updateOptionInStore(optionId: string, updatedOption: Partial<Option>) {
    const index = this.options.findIndex(o => o.id === optionId);
    if (index >= 0) {
      this.options[index] = { ...this.options[index], ...updatedOption };
    }
  }
  
  /**
   * Méthode pour supprimer une option du store
   */
  removeOptionFromStore(optionId: string) {
    this.options = this.options.filter(o => o.id !== optionId);
  }
  
  /**
   * Méthode pour obtenir toutes les options d'une catégorie
   */
  getOptionsByCategoryId(categoryId: string): Option[] {
    return this.options.filter(option => option.categoryId === categoryId);
  }
}

const optionStore = new OptionStore();
export default optionStore;
